import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import UPButton from 'components/button';
import { UPTanStackTableColumn } from 'components/tanstack-table';
import { TFunction } from 'i18next';
import {
  TIME_REGISTRATION_POLICY__COLUMN_DEFAULT,
  TIME_REGISTRATION_POLICY__COLUMN_PERMISSION,
  TIME_REGISTRATION_POLICY__COLUMN_SETTING,
  TIME_REGISTRATION_POLICY__EDIT,
  TIME_REGISTRATION_POLICY__LOCKED,
  TIME_REGISTRATION_POLICY__OVERRULABLE,
} from 'translations/constants';
import { PolicyUnit, UnitState } from 'types/time-registration-policy/ITimeRegistrationPolicy';
import { formatUnitValue } from './helpers';
import { OverrulableDot, PermissionText, UnitName } from './styles';
import { UnitDefinition } from './units';

export interface PolicyRow {
  def: UnitDefinition;
  state: UnitState;
}

export const getPolicyRowName = (row: PolicyRow): string => PolicyUnit[row.def.unit];

export const buildPolicyColumns = (
  t: TFunction,
  onEdit: (unit: PolicyUnit) => void,
): UPTanStackTableColumn<PolicyRow>[] => [
  {
    id: 'setting',
    header: t(TIME_REGISTRATION_POLICY__COLUMN_SETTING),
    cell: ({ row }) => <UnitName title={t(row.def.nameKey)}>{t(row.def.nameKey)}</UnitName>,
  },
  {
    id: 'default',
    header: t(TIME_REGISTRATION_POLICY__COLUMN_DEFAULT),
    cell: ({ row }) => (
      <span data-testid={`tr-policy-value-${getPolicyRowName(row)}`}>
        {formatUnitValue(row.def, row.state.value, t)}
      </span>
    ),
  },
  {
    id: 'permission',
    header: t(TIME_REGISTRATION_POLICY__COLUMN_PERMISSION),
    cell: ({ row }) => (
      <PermissionText data-testid={`tr-policy-permission-${getPolicyRowName(row)}`}>
        {row.state.overrulable ? <OverrulableDot /> : <LockOutlinedIcon sx={{ fontSize: 12 }} />}
        {t(row.state.overrulable ? TIME_REGISTRATION_POLICY__OVERRULABLE : TIME_REGISTRATION_POLICY__LOCKED)}
      </PermissionText>
    ),
  },
  {
    id: 'actions',
    header: '',
    align: 'right',
    cell: ({ row }) => (
      <UPButton
        text={t(TIME_REGISTRATION_POLICY__EDIT)}
        outlined
        onClick={() => onEdit(row.def.unit)}
        testId={`tr-policy-edit-${getPolicyRowName(row)}`}
      />
    ),
  },
];
